// Single source of truth for the DETERMINISTIC demo opportunities shown to a
// demo organisation. Shared by the Dashboard and the Opportunities page so both
// always display the exact same Lodge demo opportunities (no second source).
// Purely derived from the existing demo layer (demoData / recommendations).
import { OPPORTUNITIES } from "@/lib/demoData";
import { recommendationsFor } from "@/lib/recommendations";

export function buildDemoOpportunities(org = {}) {
  const objectives = org?.objectives || [];
  const base = objectives.length
    ? recommendationsFor(objectives, 5)
    : OPPORTUNITIES.slice(0, 5).map((o) => ({ title: o.title, category: o.category, potential: o.potential, objective: null }));
  return base.map((o, i) => ({
    id: `demo-${i}`,
    type: "demo",
    signal: o.title,
    opportunity: o.title,
    evidence: o.objective ? `Objectif : ${o.objective}` : "Exemple de démonstration",
    recommendedAction: "Explorer les marchés",
    source: "Demo",
    confidence: null,
    market: null,
    marketKey: null,
    objective: o.objective,
    category: o.category,
    potential: o.potential,
  }));
}
